import React from "react";
import * as T from "./types";
import * as S from "./styles";

const EmptyMessage: React.FC<T.IProps> = (props) => {
  return (
    <S.Root style={props.containerStyle} >
      <S.Message style={props.style} >
        {props.message}
      </S.Message>
    </S.Root>
  );
}

export default EmptyMessage;